export const contentPartialCancellation = {
    excursion: {
        title: 'Ausflug',
    },
    seatReservation: {
        title: 'Sitzplatzreservierung',
    },
};

export default contentPartialCancellation;
